export enum InvoiceCardEventEnum {
    PDF = 'PDF',
    CONSO = 'CONSO'
}